var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "border-bottom" },
    [
      _c(
        "ib-row",
        { class: { "pb-16": !_vm.$media.xl } },
        [
          _c("ib-col", { staticClass: "xl2" }, [
            _c(
              "p",
              {
                staticClass: "insety-16",
                class: {
                  "insetx-4": !_vm.$media.m,
                  "insetx-8": _vm.$media.l,
                  "insetx-16": _vm.$media.xl,
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "insetx-4 info",
                    class: { "start-0": !_vm.$media.m },
                  },
                  [
                    _c("svg", { attrs: { viewBox: "0 0 13 13" } }, [
                      _c("path", {
                        attrs: {
                          d: "M6.5 0A6.5 6.5 0 1013 6.5 6.5 6.5 0 006.5 0z",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M6.5 2.543a.848.848 0 10.848.848.848.848 0 00-.848-.848zM5.37 5.37v.565h.565v3.674H5.37v.565h2.26v-.565h-.565V5.37z",
                          fill: "#fff",
                        },
                      }),
                    ]),
                    _c("span", { staticClass: "tooltext" }, [
                      _vm._v(_vm._s(_vm.$t("choose_country"))),
                    ]),
                  ]
                ),
                _c("span", [_vm._v(_vm._s(_vm.$t("country_of_residence")))]),
              ]
            ),
          ]),
          _c(
            "ib-col",
            {
              staticClass: "xl10 start-4 end-4",
              class: {
                "pt-0": !_vm.$media.xl,
                "start-16": _vm.$media.m,
                "insety-16": _vm.$media.xl,
                "pr-0": _vm.$media.xl,
                "end-16": _vm.$media.m,
              },
            },
            [
              _c("ib-dropdown", {
                staticStyle: { width: "100%" },
                attrs: { data: _vm.countriesList, filtered: "" },
                model: {
                  value: _vm.selectedCountry,
                  callback: function ($$v) {
                    _vm.selectedCountry = $$v
                  },
                  expression: "selectedCountry",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }